import { render } from "./PR13-081622.vue?vue&type=template&id=5ecbe765"
import script from "./PR13-081622.vue?vue&type=script&lang=js"
export * from "./PR13-081622.vue?vue&type=script&lang=js"

import exportComponent from "/home/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__